import { Component, Input, ViewEncapsulation } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import { MessagesService } from '@core/_services/messages.service';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { NgClass } from '@angular/common';

@Component({
    selector: 'bskselect',
    standalone: true,
    imports: [
        TranslateModule,
        NgClass, 
        TableModule,
        InputTextModule
    ],
    templateUrl: './bskselect.component.html',
    styleUrl: './bskselect.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class BskselectComponent {
    @Input()
    public basketList = [];    
    public listColumns = [];
    public selectedRows: any[];  
    private bskSelected = [];
    private filteredLines: any[] = [];

    constructor(
        protected messageService: MessagesService
    ) {
        this.selectedRows = new Array();
        this.listColumns = [{header: '', field: 'Label', type: 'String', sort: null}];
    }

    public updateSelectedRows(aList) {
        this.selectedRows = aList.map(element => {
            const item = this.basketList.find(({ Information: { Name } }) => Name === element);
            return item;
            }).filter(Boolean);
        this.bskSelected = JSON.parse(JSON.stringify(this.selectedRows));
    }

    public onRowSelect(event: any) {
        this.addToList();
    }

    public onRowUnselect(event: any) {
        this.substractItem(event.data.Information.Name);  
    }

    public onselectAllChange(event: any) {
        if (event.checked) {
            this.addToList();
        } else {
            this.substractToList(this.selectedRows);
        }
    }

    public handleSelectionChange(event: any) {
        if (event.selected) {
            // Une ligne a été sélectionnée
            this.selectedRows.push(event.data);
        } else {
            // Une ligne a été désélectionnée
            const index = this.selectedRows.findIndex(row => row === event.data);
            if (index !== -1) {
                this.selectedRows.splice(index, 1);
            }
        }
    }

    public onFilter(event: any) {
        // Mise à jour des lignes filtrées
        this.filteredLines = event.filteredValue || [];
    }

    public clickcolck(event) {
        event.stopPropagation();
    }

    public getBasketList() {
        let wBasketList = [];
        this.selectedRows.forEach((elem) => {
            wBasketList.push(elem.Information.Name);
        });
        return wBasketList;
    }

    private addToList() {        
        let wIndex = -1;
        let wSelectedRows = JSON.parse(JSON.stringify(this.selectedRows));
        wSelectedRows.forEach((elem, index) => {
            wIndex = this.findBskIndex(elem.Information.Name);                        
            if (wIndex === -1) {
                this.bskSelected.push(wSelectedRows[index]);
            }
        });
        this.selectedRows = [...this.bskSelected];
    }    

    private substractToList(aSelectedRows) {        
        aSelectedRows.forEach((elem) => {
            this.substractItem(elem.Information.Name);
        });
    } 

    private substractItem(aName) {        
        let wIndex = -1;
        wIndex = this.findBskIndex(aName);            
        if (wIndex !== -1) {
            this.bskSelected.splice(wIndex, 1);
            this.selectedRows = [...this.bskSelected];
        }
    } 

    private findBskIndex(aName) {
        return this.bskSelected.findIndex((item) => {
            return item.Information.Name === aName;
        });
    }
}
